import { z } from "zod";

import {
  ORGANIZATION_TYPE,
  OrganizationType,
} from "~/admins/constants/organizations";
import { NOTIFY_LIST_SETTING } from "../constants/teamMembers";

export const teamMemberProfileSchema = z.object({
  signature_name: z
    .string()
    .min(1, "Please enter signature name.")
    .max(200, "Signature name cannot exceed 200 characters."),
  preferred_reference: z
    .string()
    .max(200, "Preferred reference cannot exceed 200 characters.")
    .optional(),
  name: z
    .string()
    .min(1, "Please enter first name.")
    .max(30, "First name cannot exceed 30 characters."),
  last_name: z
    .string()
    .min(1, "Please enter last name.")
    .max(30, "Last name name cannot exceed 30 characters."),
});

export const teamMemberProfileSchemaWithPreferredReferenceValidation = (
  organizationType?: OrganizationType,
) =>
  teamMemberProfileSchema.superRefine((data, ctx) => {
    if (
      organizationType === ORGANIZATION_TYPE.ONGOING_CARE &&
      !data.preferred_reference
    ) {
      ctx.addIssue({
        code: "custom",
        message: "Please select preferred reference",
        path: ["preferred_reference"],
      });
    }
  });

export const organizationProviderSchema = z.object({
  id: z.string(),
  is_admin: z.boolean(),
  full_name: z.string(),
});

export const notifyListFormSchema = z.discriminatedUnion("setting", [
  z.object({
    setting: z.literal(NOTIFY_LIST_SETTING.ADMINS),
    customList: z.array(z.uuid()).optional(),
  }),
  z.object({
    setting: z.literal(NOTIFY_LIST_SETTING.CUSTOM),
    customList: z.array(z.uuid()).min(1, {
      message: "Please select at least one user",
    }),
  }),
]);
